import { superAdminApi } from "./authService";
import {
  ApiResponse,
  PaginatedApiResponse,
  PaginationParams,
} from "../types/api";

const RESOURCE = "/super-admin/plans";

export type PlanCurrency = "BRL" | "USD";

/** Plan entity returned by GET /super-admin/plans. */
export interface Plan {
  id: number;
  name: string;
  description: string;
  currency: PlanCurrency;
  base_price: number;
  max_units: number;
  max_professionals: number;
  extra_unit_price: number | null;
  extra_professional_price: number | null;
  is_active: boolean;
  subscriptions_count: number;
  created_at: string;
  updated_at: string;
}

/** Payload for POST /super-admin/plans. */
export interface CreatePlanPayload {
  name: string;
  description: string;
  currency: PlanCurrency;
  base_price: number;
  max_units: number;
  max_professionals: number;
  extra_unit_price?: number | null;
  extra_professional_price?: number | null;
  is_active?: boolean;
}

/** Payload for PATCH /super-admin/plans/{id} — all fields optional. */
export type UpdatePlanPayload = Partial<CreatePlanPayload>;

export interface PlanListParams extends PaginationParams {
  search?: string;
  is_active?: boolean;
  currency?: PlanCurrency;
}

export const getPlans = async (
  params?: PlanListParams
): Promise<PaginatedApiResponse<Plan>> => {
  const response = await superAdminApi.get<PaginatedApiResponse<Plan>>(
    RESOURCE,
    { params }
  );

  return response.data;
};

export const getPlan = async (id: number): Promise<ApiResponse<Plan>> => {
  const response = await superAdminApi.get<ApiResponse<Plan>>(
    `${RESOURCE}/${id}`
  );

  return response.data;
};

export const createPlan = async (
  payload: CreatePlanPayload
): Promise<ApiResponse<Plan>> => {
  const response = await superAdminApi.post<ApiResponse<Plan>>(
    RESOURCE,
    payload
  );

  return response.data;
};

export const updatePlan = async (
  id: number,
  payload: UpdatePlanPayload
): Promise<ApiResponse<Plan>> => {
  const response = await superAdminApi.patch<ApiResponse<Plan>>(
    `${RESOURCE}/${id}`,
    payload
  );

  return response.data;
};

export const deletePlan = async (
  id: number
): Promise<ApiResponse<Record<string, never>>> => {
  const response = await superAdminApi.delete<
    ApiResponse<Record<string, never>>
  >(`${RESOURCE}/${id}`);

  return response.data;
};
